/* eslint no-param-reassign: "error" */

export default {
  SET_CURRENCY_CODE(state, data) {
    state.currencyCode = data;
  },
};
